import styled from "styled-components";

export const StatusFilterWrapper = styled.div`
  max-height: 24px;
  button {
    height: inherit;
  }
`;
//
